(function(root,factory){
  if(typeof module==='object'&&module.exports)module.exports=factory(require('./may-london-style-engine.js'));
  else root.MayLondonStyleQuiz=factory(root.MayLondonStyleEngine);
})(typeof globalThis==='object'?globalThis:this,function(E){
  const fits=['','fitted','regular','relaxed'],limit=6;
  const clean=value=>String(value).normalize('NFKC').trim().toLowerCase();
  const basicColours=[['black','#202020'],['white','#ffffff'],['cream','#f1ead9'],['beige','#d4c2a3'],['taupe','#a49383'],['grey','#858585'],['brown','#70513d'],['navy','#25364c'],['blue','#477eae'],['green','#53805c'],['red','#b93643'],['pink','#d697b0'],['purple','#89669d'],['yellow','#e2c650'],['orange','#d88a4b'],['gold','#b89b52'],['silver','#bfc2c5'],['multicolour','#978b9c']].map(([value,colour])=>({value,colour}));
  const families={
    black:['black','zwart','noir','schwarz','negro','nero','preto'],white:['white','wit','blanc','weiss','weiß','blanco','bianco','branco'],
    cream:['cream','creme','crème','ivory','off white','off-white','champagne','ecru'],beige:['beige','sand','stone','oatmeal','natural','nude'],taupe:['taupe','mushroom','greige'],
    grey:['grey','gray','light grey','dark grey','charcoal','silver grey','grijs','gris','grau','grigio','cinzento'],brown:['brown','chocolate','camel','tan','coffee','mocha','cognac','bruin','brun','braun','marron','marrón','marrone','castanho'],
    navy:['navy','navy blue','midnight blue','marine'],blue:['blue','light blue','dark blue','baby blue','sky blue','denim','cobalt','royal blue','teal','turquoise','blauw','bleu','blau','azul','blu'],
    green:['green','retro green','light green','dark green','olive','khaki','sage','mint','emerald','forest green','groen','vert','grün','verde'],
    red:['red','wine','burgundy','bordeaux','cherry','rood','rouge','rot','rojo','rosso','vermelho'],pink:['pink','baby pink','light pink','hot pink','fuchsia','dusty pink','rose','rosé','blush','magenta','roze','rosa'],
    purple:['purple','lilac','lavender','violet','plum','paars','lila','morado','viola','roxo'],yellow:['yellow','mustard','lemon','geel','jaune','gelb','amarillo','giallo','amarelo'],
    orange:['orange','coral','rust','terracotta','peach','oranje','naranja','arancione','laranja'],gold:['gold','golden','goud','doré','dorado','oro','dourado'],silver:['silver','zilver','argent','silber','plata','argento','prateado'],
    multicolour:['multicolour','multicolor','multi','mixed','monochrome','print','floral','pattern']
  };
  function colourFamilies(value){
    const name=clean(value),parts=[name,...name.split(/\s*(?:\/|,|&|\+|\band\b)\s*/)],result=[];
    for(const [family,aliases] of Object.entries(families))if(parts.some(part=>aliases.includes(part)))result.push(family);
    if(result.length>1)result.push('multicolour');return [...new Set(result)];
  }
  const colourMatches=(value,selected)=>!selected.length||selected.some(choice=>clean(choice)===clean(value)||colourFamilies(value).includes(clean(choice)));
  const colourIndex=product=>(product.options||[]).findIndex(option=>/^(color|colour|kleur|farbe|couleur|colore|cor)$/i.test(typeof option==='string'?option:option.name));
  function preferences(input={}){
    const value={handles:[],colours:[],fit:'',size:'',sizes:[],budget:null,...input};
    for(const field of ['handles','colours']){
      if(!Array.isArray(value[field])||value[field].length>(field==='handles'?limit:basicColours.length)||value[field].some(v=>typeof v!=='string'||!v.trim()||v.length>120||/[\x00-\x1f]/.test(v)))throw new RangeError(field);
      value[field]=[...new Set(value[field].map(v=>field==='colours'?clean(v):v))];
    }
    if(!fits.includes(value.fit))throw new RangeError('fit');
    if(typeof value.size!=='string'||value.size.length>24||! /^[\p{L}\p{N}\s./-]*$/u.test(value.size))throw new RangeError('size');
    value.size=value.size.trim();
    if(!Array.isArray(value.sizes)||value.sizes.length>30||value.sizes.some(size=>typeof size!=='string'||!size.trim()||size.length>80||/[\x00-\x1f<>]/.test(size)))throw new RangeError('sizes');
    value.sizes=[...new Set(value.sizes.map(size=>size.trim()))];
    if(value.budget!==null&&(!Number.isSafeInteger(value.budget)||value.budget<0||value.budget>10000000))throw new RangeError('budget');
    return value;
  }
  function catalogue(products,input={},cart=[]){
    const prefs=preferences(input),inBag=new Map(),seen=new Set();
    for(const line of cart){
      if(!Number.isSafeInteger(line.quantity)||line.quantity<0)throw new RangeError('cart');
      const id=String(line.variant_id??line.variantId);inBag.set(id,(inBag.get(id)||0)+line.quantity);
    }
    return products.filter(E.validProduct).filter(product=>{
      if(seen.has(product.handle)||!E.categories.includes(product.category))return false;
      seen.add(product.handle);return !prefs.fit||E.facts(product,'fit').includes(prefs.fit);
    }).map(product=>{
      const index=colourIndex(product);
      const variants=product.variants.map(variant=>{
        const remaining=E.capacity(variant)-(inBag.get(String(variant.id))||0);
        const colour=!prefs.colours.length||index>=0&&colourMatches(variant.options?.[index]??'',prefs.colours);
        return {...variant,available:variant.available&&remaining>0&&colour,inventory:Number.isFinite(remaining)?remaining:variant.inventory};
      }).filter(variant=>Number.isFinite(E.price({...product,variants:[variant]},prefs))&&(prefs.budget===null||variant.price<=prefs.budget));
      return {...product,variants};
    }).filter(product=>Number.isFinite(E.price(product,prefs)));
  }
  function plan(products,input={},cart=[]){
    const prefs=preferences(input),pool=catalogue(products,prefs,cart);
    const liked=products.filter(E.validProduct).filter(p=>prefs.handles.includes(p.handle)),categories=new Set(liked.map(p=>p.category));
    const stale=prefs.handles.filter(handle=>!pool.some(p=>p.handle===handle));
    const score=p=>(prefs.handles.includes(p.handle)?100:0)+(categories.has(p.category)?10:0);
    const ranked=[...pool].sort((a,b)=>score(b)-score(a)||E.price(a,prefs)-E.price(b,prefs)||a.handle.localeCompare(b.handle));
    const looks=[],seen=new Set();
    // Keep visual choices ahead of category matches; never infer a style or fit from a photo.
    for(const product of ranked.slice(0,24)){
      for(const look of E.suggestions(pool,prefs,{anchor:[{kind:'shop',handle:product.handle,variantId:'',quantity:1}],limit:2})){
        const signature=JSON.stringify(look.lines.map(line=>line.handle).sort());
        if(seen.has(signature)||(prefs.budget!==null&&look.subtotal>prefs.budget))continue;
        seen.add(signature);looks.push(look);if(looks.length===4)break;
      }
      if(looks.length===4)break;
    }
    return {preferences:prefs,products:ranked,looks,stale};
  }
  function colourChoices(products){
    const values=new Map();
    for(const product of products.filter(E.validProduct)){
      const index=colourIndex(product);if(index<0)continue;
      for(const variant of product.variants){
        const name=variant.options?.[index];if(E.capacity(variant)<1||typeof name!=='string'||!name.trim()||name.length>120)continue;
        const value=clean(name),native=(product.colours||[]).find(item=>typeof item.name==='string'&&clean(item.name)===value);
        if(!values.has(value)||native)values.set(value,native||{name});
      }
    }
    return [...values].map(([value,item])=>({...item,value}));
  }
  function recommend(products,input={},cart=[]){
    const prefs=preferences(input),exact=plan(products,prefs,cart);
    if(exact.looks.length)return {...exact,relaxed:[]};
    const fields=[['fit','',1],['colours',[],2],['budget',null,10],['size','',50]];
    const attempts=[];
    for(let mask=1;mask<16;mask++){
      const changed=fields.filter((field,index)=>mask&(1<<index)).filter(([key])=>key==='budget'?prefs[key]!==null:key==='size'?E.sizes(prefs).length:!!prefs[key].length);
      if(changed.length)attempts.push({changed,penalty:changed.reduce((sum,field)=>sum+field[2],0)});
    }
    attempts.sort((a,b)=>a.penalty-b.penalty);
    const tried=new Set();
    for(const {changed} of attempts){
      const candidate={...prefs,...Object.fromEntries(changed.map(([key,value])=>[key,value]))};
      if(changed.some(([key])=>key==='size'))candidate.sizes=[];
      const signature=JSON.stringify(candidate);
      if(tried.has(signature))continue;tried.add(signature);
      const alternative=plan(products,candidate,cart);
      if(alternative.looks.length)return {...alternative,preferences:prefs,stale:exact.stale,relaxed:changed.map(([key])=>key)};
    }
    return {...exact,relaxed:[]};
  }
  return {preferences,catalogue,plan,recommend,colourChoices,basicColours,colourFamilies,colourMatches,fits,limit};
});
